@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.container {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  justify-items: flex-start;
  text-align: center;

  &Row {
    align-items: end;
    flex-direction: row;
    gap: 10px;
  }

  &Disabled {
    opacity: 0.4;
    pointer-events: none;
  }

  &Label {
    line-height: 1;
    margin-bottom: 5px;

    @include core.font(core.$m, core.$regular, map.get(core.$fonts, label));
  }

  &Toggle {
    background-color: map.get(core.$fonts, fontSecondaryDisabled);
    border-radius: 10px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    height: 20px;
    position: relative;
    vertical-align: middle;
    width: 36px;

    &OffLabel {
      left: 68%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    &OnLabel {
      left: 30%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    &Point {
      background-color: map.get(core.$colors, simpleWhite);
      border-radius: 50%;
      box-sizing: border-box;
      height: 16px;
      left: 27%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      transition: left 0.4s;
      width: 16px;
    }

    &Large {
      border-radius: 12px;
      height: 24px;
      width: 52px;

      & > .containerTogglePoint {
        height: 20px;
        left: 22%;
        width: 20px;
      }
    }

    &Small {
      border-radius: 12px;
      height: 20px;
      width: 36px;

      & > .containerTogglePoint {
        height: 16px;
        width: 16px;
      }
    }
  }

  &Input {
    border: none;
    cursor: pointer;
    height: 20px;
    margin: 0;
    opacity: 0;
    position: absolute;
    width: 36px;

    &:checked + .containerToggle {
      background-color: map.get(core.$colors, accent);

      & > .containerTogglePoint {
        border-color: map.get(core.$colors, simpleWhite);
        left: 73%;
      }
    }

    &:checked + .containerToggleLarge {
      & > .containerTogglePoint {
        left: 78%;
      }
    }
  }
}
